import React, { useState } from "react";
import { Check, X, MessageCircle, FileInput as FormInput, ImageOff } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const categories = [{
  id: 1,
  title: "MeetingBoard",
  badge: "Microsoft Teams",
  imageSrc: "https://avtecsa.com/wp-content/uploads/2026/09/elevate-meetings-in-every-setting-discover-the-enhanced-yealink-meetingboard.webp?v=6bisrnwcytw",
  imageSrcset: "https://avtecsa.com/wp-content/uploads/2026/09/elevate-meetings-in-every-setting-discover-the-enhanced-yealink-meetingboard.webp?v=44jj4unkmwm-wvc-srcset",
  imageSizes: "https://avtecsa.com/wp-content/uploads/2026/09/elevate-meetings-in-every-setting-discover-the-enhanced-yealink-meetingboard.webp?v=qljmaio6krs-wvc-sizes",
  imageAlt: "Yealink MeetingBoard"
}, {
  id: 2,
  title: "Serie MeetingBar (A10, A20, A30)",
  badge: "Microsoft Teams",
  imageSrc: "https://avtecsa.com/wp-content/uploads/2026/09/a40-sec1.jpeg?v=8v9jhqnyt3y",
  imageSrcset: "https://avtecsa.com/wp-content/uploads/2026/09/a40-sec1.jpeg?v=8fja0c5amex-wvc-srcset",
  imageSizes: "https://avtecsa.com/wp-content/uploads/2026/09/a40-sec1.jpeg?v=xomyouwpae-wvc-sizes",
  imageAlt: "Yealink MeetingBar Series"
}, {
  id: 3,
  title: "Serie MVC",
  badge: "Microsoft Teams",
  imageSrc: "https://avtecsa.com/wp-content/uploads/2026/09/mvc-series-33.png?v=7cw0o17ovz7",
  imageSrcset: "https://avtecsa.com/wp-content/uploads/2026/09/mvc-series-33.png?v=db3j9qdq1bt-wvc-srcset",
  imageSizes: "https://avtecsa.com/wp-content/uploads/2026/09/mvc-series-33.png?v=kv0sg1kiqhq-wvc-sizes",
  imageAlt: "Yealink MVC Series"
}, {
  id: 4,
  title: "SkySound",
  badge: "Microsoft Teams",
  imageSrc: "https://avtecsa.com/wp-content/uploads/2026/09/20250106065028902d72a.png?v=pcl6kb05pre",
  imageSrcset: "https://avtecsa.com/wp-content/uploads/2026/09/20250106065028902d72a.png?v=04mnkgckfidj-wvc-srcset",
  imageSizes: "https://avtecsa.com/wp-content/uploads/2026/09/20250106065028902d72a.png?v=9j7uxowpbtw-wvc-sizes",
  imageAlt: "Yealink SkySound"
}, {
  id: 5,
  title: "Teléfonos Serie T5",
  badge: "SIP",
  imageSrc: "https://avtecsa.com/wp-content/uploads/2026/09/t5.jpg?v=rjvxgh5zoe",
  imageSrcset: "https://avtecsa.com/wp-content/uploads/2026/09/t5.jpg?v=legztm8e60l-wvc-srcset",
  imageSizes: "https://avtecsa.com/wp-content/uploads/2026/09/t5.jpg?v=r5uech4my3k-wvc-sizes",
  imageAlt: "Yealink T58W Pro - Teléfono IP Serie T5"
}, {
  id: 6,
  title: "Teléfonos Serie T4",
  badge: "SIP",
  imageSrc: "https://avtecsa.com/wp-content/uploads/2026/09/m21.jpg?v=9ejogz7tldl",
  imageSrcset: "https://avtecsa.com/wp-content/uploads/2026/09/m21.jpg?v=fvlos3bd03s-wvc-srcset",
  imageSizes: "https://avtecsa.com/wp-content/uploads/2026/09/m21.jpg?v=9fgxt5nqs6w-wvc-sizes",
  imageAlt: "Yealink T48U - Teléfono IP Serie T4"
}, {
  id: 7,
  title: "Teléfonos Serie T3",
  badge: "SIP",
  imageSrc: "https://avtecsa.com/wp-content/uploads/2026/09/t333.png?v=8w1f0zigyva",
  imageSrcset: "https://avtecsa.com/wp-content/uploads/2026/09/t3.png?v=msk1ugp71bq-wvc-srcset",
  imageSizes: "https://avtecsa.com/wp-content/uploads/2026/09/t3.png?v=3esk4fzivyu-wvc-sizes",
  imageAlt: "Yealink T33G - Teléfono IP Serie T3"
}, {
  id: 8,
  title: "Teléfonos de Conferencia",
  badge: "SIP",
  imageSrc: "https://avtecsa.com/wp-content/uploads/2026/09/conf.png?v=8dxcnlfzx19",
  imageSrcset: "https://avtecsa.com/wp-content/uploads/2026/09/conf.png?v=qpjrgiirs8s-wvc-srcset",
  imageSizes: "https://avtecsa.com/wp-content/uploads/2026/09/conf.png?v=etr9re905xj-wvc-sizes",
  imageAlt: "Yealink CP965 - Teléfono de Conferencia"
}, {
  id: 9,
  title: "Teléfonos DECT Inalámbricos (Serie W)",
  badge: "SIP",
  imageSrc: "https://avtecsa.com/wp-content/uploads/2026/09/dect.png?v=opyumen9pjh",
  imageSrcset: "https://avtecsa.com/wp-content/uploads/2026/09/dect.png?v=ozw3hjyxp8p-wvc-srcset",
  imageSizes: "https://avtecsa.com/wp-content/uploads/2026/09/dect.png?v=uz8ovvo4x9-wvc-sizes",
  imageAlt: "Yealink W73P - Teléfono DECT Inalámbrico"
}, {
  id: 10,
  title: "Diademas y Auriculares Profesionales",
  badge: "Microsoft Teams & SIP",
  imageSrc: "https://avtecsa.com/wp-content/uploads/2026/09/yhs.png?v=lnjep2umkqp",
  imageSrcset: "https://avtecsa.com/wp-content/uploads/2026/09/yhs.png?v=e3drtwozwkd-wvc-srcset",
  imageSizes: "https://avtecsa.com/wp-content/uploads/2026/09/yhs.png?v=es8s3v8qdat-wvc-sizes",
  imageAlt: "Yealink BH72 - Diadema Bluetooth Profesional"
}];
const features = [{
  categoryId: 1,
  text: "Pantalla de colaboración todo en uno"
}, {
  categoryId: 1,
  text: "Pizarra interactiva nativa"
}, {
  categoryId: 1,
  text: "Cámara y audio premium integrados"
}, {
  categoryId: 2,
  text: "Barras de video integradas para salas"
}, {
  categoryId: 2,
  text: "Configuración simple plug-and-play"
}, {
  categoryId: 2,
  text: "Seguimiento de cámara impulsado por IA"
}, {
  categoryId: 3,
  text: "Kits modulares con mini-PC"
}, {
  categoryId: 3,
  text: "Paneles táctiles intuitivos"
}, {
  categoryId: 3,
  text: "Soluciones flexibles para cualquier sala"
}, {
  categoryId: 4,
  text: "Soluciones de audio de techo"
}, {
  categoryId: 4,
  text: "Cobertura de voz superior"
}, {
  categoryId: 4,
  text: "Diseño discreto y elegante"
}, {
  categoryId: 5,
  text: "Teléfonos multimedia de alta gama"
}, {
  categoryId: 5,
  text: "Pantallas ajustables de alta resolución"
}, {
  categoryId: 5,
  text: "Audio HD óptimo para ejecutivos"
}, {
  categoryId: 6,
  text: "Teléfonos de escritorio profesionales"
}, {
  categoryId: 6,
  text: "Diseño elegante y con múltiples funciones"
}, {
  categoryId: 6,
  text: "Excelente calidad de sonido"
}, {
  categoryId: 7,
  text: "Teléfonos empresariales de nivel básico"
}, {
  categoryId: 7,
  text: "Rendimiento confiable y duradero"
}, {
  categoryId: 7,
  text: "Interfaz fácil de usar"
}, {
  categoryId: 8,
  text: "Soluciones de conferencia con pantalla táctil"
}, {
  categoryId: 8,
  text: "Captación de voz de 360 grados"
}, {
  categoryId: 8,
  text: "Conectividad inalámbrica opcional"
}, {
  categoryId: 9,
  text: "Estaciones base y terminales W70B/W73P/W78P/W79P"
}, {
  categoryId: 9,
  text: "Terminal rugerizado W59R con certificación IP67"
}, {
  categoryId: 9,
  text: "Sistema multicelda W80/W90 para grandes instalaciones"
}, {
  categoryId: 9,
  text: "Hasta 300m de alcance en exterior y 30 horas de conversación"
}, {
  categoryId: 10,
  text: "Serie BH Bluetooth (BH72, BH76) con cancelación activa de rural"
}, {
  categoryId: 10,
  text: "Serie WH DECT inalámbrica (WH62, WH63, WH66) con pantalla táctil"
}, {
  categoryId: 10,
  text: "Serie UH USB con cable (UH34, UH36, UH38) para PC y teléfonos IP"
}, {
  categoryId: 10,
  text: "Tecnología Acoustic Shield y Busylight visible en 360°"
}];
export default function CategoriasDeProductos() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [failedImages, setFailedImages] = useState<Record<number, boolean>>({});
  const handleImageError = (id: number) => {
    setFailedImages(prev => ({
      ...prev,
      [id]: true
    }));
  };
  return <section id="categorías-de-productos" className="bg-muted py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col gap-16 md:gap-24">
          {categories.map((category, index) => {
          const categoryFeatures = features.filter(f => f.categoryId === category.id);
          const isEven = index % 2 === 0;
          const hasError = failedImages[category.id];
          return <div key={category.id} data-index={index} className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
                <div className={`lg:col-span-8 order-1 ${isEven ? "lg:order-1" : "lg:order-2"}`}>
                  <div className="relative w-full aspect-video lg:aspect-[16/9] rounded-xl overflow-hidden shadow-lg bg-background flex items-center justify-center p-4">
                    {hasError ? <div className="flex flex-col items-center justify-center text-muted-foreground gap-3">
                        <ImageOff className="size-12 stroke-1" />
                        <span className="text-sm font-medium">{category.imageAlt}</span>
                      </div> : <img src={category.imageSrc} data-wvc-srcset={category.imageSrcset} data-wvc-sizes={category.imageSizes} alt={category.imageAlt} className="w-full h-full object-cover" loading="lazy" onError={() => handleImageError(category.id)} />}
                  </div>
                </div>

                <div className={`lg:col-span-4 order-2 flex flex-col justify-center ${isEven ? "lg:order-2" : "lg:order-1"}`}>
                  <div className="mb-3">
                    <span className="inline-flex items-center text-xs font-semibold uppercase tracking-wider px-2.5 py-1 rounded-md bg-primary/10 text-primary border border-primary/20">
                      {category.badge}
                    </span>
                  </div>

                  <h3 className="text-2xl md:text-3xl font-bold font-default text-foreground mb-6">
                    {category.title}
                  </h3>
                  
                  <ul className="space-y-4 mb-8">
                    {categoryFeatures.map((feature, fIndex) => <li key={fIndex} data-index={fIndex} className="flex items-start gap-3">
                        <Check className="size-5 text-chart-3 shrink-0 mt-0.5" />
                        <span className="text-muted-foreground text-base">
                          {feature.text}
                        </span>
                      </li>)}
                  </ul>

                  <div>
                    <Button onClick={() => setIsContactModalOpen(true)} className="bg-chart-3 hover:bg-chart-3/90 text-white shadow-md">
                      Explorar
                    </Button>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>

      {isContactModalOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
          <div className="bg-background w-full max-w-md rounded-xl shadow-2xl overflow-hidden border border-border animate-in fade-in zoom-in duration-300">
            <div className="p-6 border-b border-border flex justify-between items-center">
              <h2 className="text-xl font-bold text-foreground">Solicitar Información</h2>
              <Button variant="ghost" size="icon" onClick={() => setIsContactModalOpen(false)} className="rounded-lg">
                <X className="size-5" />
              </Button>
            </div>
            <div className="p-8 space-y-4">
              <p className="text-muted-foreground mb-6">
                Elija su método preferido para contactarnos y obtener más detalles sobre nuestras soluciones Yealink.
              </p>
              <div className="grid gap-4">
                <Button asChild variant="outline" className="w-full justify-start h-14 text-base gap-4 border-primary/20 hover:border-primary hover:bg-primary/5">
                  <Link to="#formulario-de-contacto-solicitar-demo" onClick={() => setIsContactModalOpen(false)}>
                    <FormInput className="size-6 text-primary" />
                    <span>Formulario de Contacto</span>
                  </Link>
                </Button>
                <Button asChild className="w-full justify-start h-14 text-base gap-4 bg-chart-3 hover:bg-chart-3/90 text-white">
                  <Link to="https://wa.me/50687176886" newTab onClick={() => setIsContactModalOpen(false)}>
                    <MessageCircle className="size-6" />
                    <span>Contactar por WhatsApp</span>
                  </Link>
                </Button>
              </div>
            </div>
            <div className="p-4 bg-muted/50 flex justify-end">
              <Button variant="ghost" onClick={() => setIsContactModalOpen(false)}>
                Cerrar
              </Button>
            </div>
          </div>
        </div>}
    </section>;
}